<script setup>
import { dateFormatterUTC } from '@/Common/utils.js';
import PropertyListItem from '@/Pages/HeaderAnalysis/Partials/PropertyListItem.vue';

defineProps({
  rdap: Object,
  domainFallback: String,
  contextTitle: {
    type: [String, null],
    default: null
  }
});
</script>

<template>
  <div>
    <div class="font-bold">
      {{ contextTitle && contextTitle + ' '
      }}{{ $t('header_analysis.partials.rdap_detail.domain') }}
    </div>
    <PropertyListItem
      :title="$t('header_analysis.partials.rdap_detail.name')"
      :value="rdap?.domain_name ?? domainFallback"
      empty-value="–"
      :title-class="['w-1/3', 'shrink-0']"
    />
    <PropertyListItem
      :title="$t('header_analysis.partials.rdap_detail.created')"
      :value="
        rdap?.created && dateFormatterUTC.format(Date.parse(rdap.created))
      "
      empty-value="–"
      :title-class="['w-1/3', 'shrink-0']"
    />
    <PropertyListItem
      :title="$t('header_analysis.partials.rdap_detail.updated')"
      :value="
        rdap?.updated && dateFormatterUTC.format(Date.parse(rdap.updated))
      "
      empty-value="–"
      :title-class="['w-1/3', 'shrink-0']"
    />
    <PropertyListItem
      :title="$t('header_analysis.partials.rdap_detail.expires')"
      :value="
        rdap?.expires && dateFormatterUTC.format(Date.parse(rdap.expires))
      "
      empty-value="–"
      :title-class="['w-1/3', 'shrink-0']"
    />

    <!-- section -->
    <div class="mt-2 font-bold">
      {{ contextTitle && contextTitle + ' '
      }}{{ $t('header_analysis.partials.rdap_detail.name_servers') }}
    </div>
    <div v-if="rdap?.nameservers">{{ rdap.nameservers.join(', ') || '–' }}</div>
    <div v-else>–</div>

    <!-- section -->
    <div class="mt-2 font-bold">
      {{ contextTitle && contextTitle + ' '
      }}{{ $t('header_analysis.partials.rdap_detail.registrar') }}
    </div>
    <PropertyListItem
      :title="$t('header_analysis.partials.rdap_detail.name')"
      :value="rdap?.registrar_name"
      empty-value="–"
      :title-class="['w-1/3', 'shrink-0']"
    />
    <PropertyListItem
      :title="$t('header_analysis.partials.rdap_detail.abuse_email')"
      :value="rdap?.registrar_abuse_email"
      empty-value="–"
      :title-class="['w-1/3', 'shrink-0']"
    />
    <PropertyListItem
      :title="$t('header_analysis.partials.rdap_detail.abuse_phone')"
      :value="rdap?.registrar_abuse_phone"
      empty-value="–"
      :title-class="['w-1/3', 'shrink-0']"
    />

    <!-- section -->
    <div class="mt-2 font-bold">
      {{ contextTitle && contextTitle + ' '
      }}{{ $t('header_analysis.partials.rdap_detail.registrant') }}
    </div>
    <PropertyListItem
      :title="$t('header_analysis.partials.rdap_detail.name')"
      :value="rdap?.registrant_name"
      empty-value="–"
      :title-class="['w-1/3', 'shrink-0']"
    />
    <PropertyListItem
      :title="$t('header_analysis.partials.rdap_detail.organization')"
      :value="rdap?.registrant_organization"
      empty-value="–"
      :title-class="['w-1/3', 'shrink-0']"
    />
  </div>
</template>
